import * as React from 'react'
import I18n from '../../../../core/i18n'
import { agentService } from '../../../../core/services'
import { InputText } from '../../../atoms'
import AgentLayoutNew from '../_layouts/new'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

const FIELDS = {
  name: 'name',
  position: 'position',
}

const title = I18n.t('admin.create_new', {
  model: I18n.t('range_tags', { scope: 'activerecord.models' }),
})

const RangeTagsNew: React.FC<{}> = props => {
  const handleSubmit = React.useCallback(async (_, values) => {
    const { flush } = await agentService.createRangeTag(values)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = '/agent/range_tags'
  }, [])

  return (
    <AgentLayoutNew
      model="range_tags"
      title={title}
      fields={FIELDS}
      indexLink="/agent/range_tags"
      formItems={
        <>
          <InputText required={true} name="name" defaultValue="" label={I18n.t('generic.name')} />
          <InputText
            required={true}
            name="position"
            defaultValue=""
            label={I18n.t('generic.position')}
          />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default RangeTagsNew
